import IntegrationsPage from '../components/IntegrationsPage';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  '3D Plugins | Cartwheel',
  'Use Cartwheel 3D plugins to bring performance capture, motion generation, and retargeting into existing workflows.',
);

export default IntegrationsPage;
